let status = "unknown";
const waiters = new Set();

export function markNotificationPromptPending() {
    status = "pending";
}

export function markNotificationPromptSettled() {
    if (status === "settled") return;
    status = "settled";
    waiters.forEach((fn) => fn());
    waiters.clear();
}

export function resetNotificationPromptGate() {
    status = "unknown";
}

export function onNotificationPromptSettled(fn) {
    if (status === "settled") {
        fn();
        return () => {};
    }
    waiters.add(fn);
    return () => waiters.delete(fn);
}
